module.exports = __webpack_public_path__ + "img/on.be5030ca.webp";